// extracted by mini-css-extract-plugin
module.exports = {"questionContainer":"Question_questionContainer__1WOTW","options":"Question_options__1SDIF"};